// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FNplT","rootNoMargin":"styles_rootNoMargin__12RiZ"};